import * as React from 'react';

import { Translate } from 'react-localize-redux';

import Typography from '@components/basics/typography';

interface NotificationLabelInviteTemplateProps {
  username: string;
  labelname: string;
  isArtist: boolean;
}

export const NotificationLabelInviteTemplate: React.FC<
  NotificationLabelInviteTemplateProps
> = ({ username, labelname, isArtist }) => {
  return (
    <>
      <Typography weight="700">{username}&nbsp;</Typography>
      <Typography>
        <Translate id="NOTIFICATION.LABEL_REQUEST.TEXT" />
        &nbsp;
      </Typography>
      <Typography weight="700">{labelname}</Typography>&nbsp;
      <Typography>
        <Translate
          id={
            isArtist
              ? 'NOTIFICATION.LABEL_REQUEST.ARTIST'
              : 'NOTIFICATION.LABEL_REQUEST.OPERATOR'
          }
        />
      </Typography>
    </>
  );
};

export default NotificationLabelInviteTemplate;
